/**
 * macOS Korean IME emits NFD (decomposed jamo) while labels in code and API
 * payloads are typically NFC (precomposed). The two render identically but
 * compare as different codepoints, so any search that scans codepoints — cmdk's
 * scorer, `String.includes` — misses unless both sides are in one form.
 */
export const toNfc = (value: string): string => value.normalize('NFC');

/**
 * Search folding for callers that compare strings themselves (`includes`,
 * `===`). The step order is fixed here so every call site folds identically.
 * Pass to a scorer that already case-folds (cmdk) and you want `toNfc` instead.
 */
export const foldForSearch = (value: string): string => toNfc(value).toLowerCase().trim();
